import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '~/components';
import { FormCad } from '../components';
import initialData from './initialData';
import schema from './schema'
import { updateRecurso, showRecurso, loadRecursos } from '~/store/modules/recurso/action';



const Edit = () => {
  let history = useHistory();
  const [recursoEdit, setRecursoEdit] = useState(initialData);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const { recurso_id } = useParams();
  const { recurso, errors } = useSelector(({ RecursoReducer }) => RecursoReducer);

  useEffect(() => {
    dispatch(showRecurso(recurso_id));
  }, [dispatch, recurso_id]);

  useEffect(() => {
    if (recurso.id === parseInt(recurso_id)) {
      setRecursoEdit(recurso);
    }
  }, [recurso, recurso_id]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setUpdated(true);
    }
  }, [errors]);

  useEffect(() => {
    if (updated) {
      Swal.fire('Sucesso', 'Registro atualizada com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadRecursos());
        }
      );
    }
  }, [updated, history, dispatch]);

  const handleClose = () => {
    history.goBack('/recurso');
  };


  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(recursoEdit)) {
      let yup_errors = {};
      schema.validate(recursoEdit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(updateRecurso(recursoEdit, recurso_id));
    }

  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Recurso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {recurso.id === parseInt(recurso_id) ? (
              <FormCad
                errors={errorsValidate}
                recurso={recursoEdit}
                handleSubmit={handleSubmit}
                schema={schema}
                setRecurso={setRecursoEdit}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link className="btn btn-default" to="/recurso">
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button className="btn btn-success" form="form_recurso" type="submint">
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
